module.exports = "mutation ($planId: Int!) {\n    unsubscribeFromPlan(plan: $planId)\n}\n"